import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function DashboardOverview() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                Dashboard Overview
                </div>

                <div  className="infoDescHeader">
                HOME (DASHBOARD)
                </div>

                <div className="infoDesc"> 
                The Home Dashboard is your central hub for managing and monitoring your account. Here, you’ll find your bio, news feed, and an overview of your recent activities, including the status of your recent releases and promotional campaigns. It provides quick access to essential tools and insights, allowing you to stay updated on your progress at a glance.
                 </div>

                 <div className="infoDescHeader">
                 RELEASE MUSIC
                 </div>

                 <div className="infoDesc"> 
                 The Release Music section guides you through the process of uploading and distributing your tracks across multiple platforms. Whether you're releasing a single, an album, or an EP, this is where you’ll input all necessary details, choose your release date, and ensure your music reaches your audience on their preferred streaming services.
                 </div>

                 <div className="infoDescHeader">
                 MY MUSIC
                 </div>

                 <div className="infoDesc"> 
                 My Music is your personal library, housing all the tracks and albums you’ve uploaded. This section allows you to manage your catalog, edit metadata, update album art, and track the status of your releases. It’s the go-to place for reviewing and refining your music collection.
                 </div>

                 <div className="infoDescHeader">
                 ANALYTICS
                 </div>

                 <div className="infoDesc"> 
                 Analytics offers detailed insights into your music's performance. Track your plays, downloads, and audience demographics across various platforms. Understand where your music is resonating most, identify trends, and use this data to make informed decisions about your next steps in music distribution and promotion.
                 </div>

                 <div className="infoDescHeader">
                 MONEY (WALLET)
                 </div>

                 <div className="infoDesc"> 
                 The Money (Wallet) section is where you can monitor your earnings from music sales, streaming, and other revenue streams. Here, you can view your balance, track payment history, and withdraw funds. It’s your financial hub, giving you control over your income from your music career.
                 </div>

                 <div className="infoDescHeader">
                 PROMOTE YOURSELF
                 </div>

                 <div className="infoDesc"> 
                 Promote Yourself provides tools and strategies to help you market your music effectively. Access promotional campaigns, social media tips, and advertising options designed to increase your visibility and grow your fanbase. This section empowers you to reach new audiences and build your brand.
                 </div>

                 <div className="infoDescHeader">
                 EXCLUSIVES
                 </div>

                 <div className="infoDesc"> 
                 Exclusives offer special content and opportunities available only to members. This could include early access to new features, exclusive distribution deals, promotional opportunities, or insider industry tips. It’s where you can gain an edge in your music career with unique benefits.
                 </div>

                 <div className="infoDescHeader">
                 SETTINGS
                 </div>

                 <div className="infoDesc"> 
                 The Settings section allows you to customize your account preferences. Manage your profile, configure notifications, set up payment methods, and adjust privacy settings. It’s the place to tailor your experience to your needs and ensure your account is secure and up-to-date.
                 </div>

                 <div className="infoDescHeader">
                 SUPPORT
                 </div>

                 <div className="infoDesc"> 
                 Support is your resource for assistance with any issues or questions you may have. Access FAQs, get in touch with customer service, or find guides on using the platform. Whether you need technical help or advice on music distribution, this is where you’ll find the support you need.
                 </div>


                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default DashboardOverview;